export default __webpack_public_path__ + "static/media/basis_trading_vault_strategy.7040a859.gif";